module.exports = __webpack_public_path__ + "img/graphic_design.ab5bc23c.jpg";